window.alpineButtonNextSectionData = function()
{
    const headerHeight = document.querySelector("#header").getBoundingClientRect().height;

    return {
        isNodeBefore(element1, element2){
            return (element2.compareDocumentPosition(element1) & (Node.DOCUMENT_POSITION_PRECEDING | Node.DOCUMENT_POSITION_CONTAINS)) != 0;
        },

        goToNextSection(){
            let sections = document.querySelectorAll(".section");

            let currentPosition = window.innerWidth > 1024 ?  window.scroll.scroll.instance.scroll.y : document.documentElement.scrollTop;

            for (let i=0; i < sections.length; i++){
                let section = sections[i];

                if (this.isNodeBefore(this.$el, section)){

                    let positionY = currentPosition + (section.getBoundingClientRect().top - ( headerHeight + 32 ));

                    console.log(document.body.scrollTop, positionY);

                    window.scroll.scrollTo(positionY, {
                        easing: [0.40, 0.00, 0.60, 1.00],
                        duration: 600,
                    });

                    return;
                }
            }
        }
    };
};
